<template>
	<main class="single post main" :key="currentPageID" :class="'type-' + currentPostType">
		<template v-if="!isProtected">
			<div v-if="currentPage" class="page-wrapper-sizer content-padding">
				<div class="page-header" :class="currentPage && currentPage.featured_image ? 'has-image' : 'no-image'">
					<div class="margin-bottom-lg info-header container container--small">
						<GoUpButton />
						<h1 class="page-title font--600">{{ currentPage.title }}</h1>
						<p
							class="margin-top-lg excerpt content-excerpt font-size--26"
							v-if="pageExcerpt()"
							v-html="pageExcerpt()"
						></p>
					</div>
					<div v-if="currentPage.featured_image" class="post-img-hold container container--a">
						<WpImage
							v-if="!currentPage.acf.video"
							:image="currentPage.featured_image"
							size="extra_large"
							class="featured-image"
							background
							cover
							spacer
						/>
						<Video
							class="featured-image responsive-embed module-video_block featured-video"
							v-if="currentPage.acf.video && currentPage.featured_image"
							:data="{
								video_placeholder: currentPage.featured_image,
								video: currentPage.acf.video,
							}"
						/>
						<div
							class="container container--small after-image"
							:class="{ 'has-caption': currentPage.featured_image.caption }"
						>
							<p class="image-caption" v-if="currentPage.featured_image.caption">
								{{ currentPage.featured_image.caption }}
							</p>
						</div>
					</div>
				</div>
			</div>

			<div
				class="content-padding summary margin-bottom-lg margin-top-lg"
				v-if="currentPage && currentPage.acf && currentPage.acf.en_desc && currentPage.acf.description"
			>
				<Accordion class="eng-summary">
					<AccordionItem @close="accordionOpen = false" @open="accordionOpen = true">
						<div class="heading" slot="accordion-trigger">
							<button class="font--600 open-btn">
								<span class="txt">English summary</span>
								<span class="icon" v-html="!accordionOpen ? plus : minus"></span>
							</button>
						</div>
						<div slot="accordion-content" class="summary-content">
							<div class="html-content" v-html="currentPage.acf.description"></div>
						</div>
					</AccordionItem>
				</Accordion>
			</div>

			<ModuleBuilder />

			<div class="content-padding">
				<RelatedEvents
					v-if="relatedEventsData"
					:archive-button="false"
					class="related-event-post no-padding-top margin-top-md"
					:data="relatedEventsData"
				/>
			</div>
			<div v-if="publishDate" class="post-meta-publish margin-top-sm content-padding">
				<div class="container container--small">
					Published {{ publishDate.format('DD.MM.YYYY') }} in {{ categories }}
				</div>
			</div>
			<SocialShareArticle />

			<div class="content-padding">
				<RelatedPosts
					:related="true"
					v-if="relatedNewsData"
					class="related-article-post no-padding-top margin-top-xl"
					:data="relatedNewsData"
				/>
			</div>
		</template>
		<PasswordProtection v-else />
	</main>
</template>

<script>
import ModuleBuilder from '@/components/ModuleBuilder'
import RelatedPosts from '@/components/modules/Articles'
import RelatedEvents from '@/components/modules/Events'
import SocialShareArticle from '@/components/elements/SocialShareArticle'
import PasswordProtection from '@/components/parts/PasswordProtection'
import WpImage from '@/components/elements/WpImage'
import GoUpButton from '@/components/parts/GoUpButton'
import Accordion from '@/components/elements/accordion'
import AccordionItem from '@/components/elements/accordion-item'
import { formatOutputValues } from '@/helpers'
import Video from '@/components/modules/Video_block'

import moment from 'moment'
moment.locale('nb-NO')

import { plus, minus } from '@/icons'

import { mapGetters } from 'vuex'

export default {
	name: 'single-post',
	components: {
		ModuleBuilder,
		PasswordProtection,
		SocialShareArticle,
		RelatedPosts,
		WpImage,
		GoUpButton,
		Accordion,
		AccordionItem,
		RelatedEvents,
		Video,
	},
	data() {
		return {
			plus: plus('#222831'),
			minus: minus('#222831'),
			accordionOpen: false,
			publishDate: null,
		}
	},
	created() {
		this.publishDate = this.currentPage.date ? moment(this.currentPage.date) : false
	},
	computed: {
		...mapGetters(['currentPageID', 'currentPage', 'currentPostType']),
		relatedEventsData() {
			if (!this.currentPageID) return null
			//let taxonomy = 'category';
			if (!this.currentPage.acf.related_event) return false
			return {
				limit: 1,
				include: this.currentPage.acf.related_event,
				all_events: true,
			}
		},
		categories() {
			let cats = []
			if (
				this.currentPage &&
				this.currentPage.acf &&
				this.currentPage.acf.post_category &&
				this.currentPage.acf.post_category.name
			) {
				//single choice fallback
				cats = [this.currentPage.acf.post_category]
			} else if (
				this.currentPage &&
				this.currentPage.acf &&
				this.currentPage.acf.post_category &&
				this.currentPage.acf.post_category.length
			) {
				//multi choice fallback
				cats = this.currentPage.acf.post_category
			}
			cats = cats && cats.length ? cats.map((c) => c.name) : []
			return formatOutputValues(cats)
		},
		isProtected() {
			let isProtected = false
			if (this.currentPage && this.currentPage.is_protected === true) {
				isProtected = true
			}
			return isProtected
		},
		relatedNewsData() {
			if (!this.currentPageID) return null
			//let taxonomy = 'category';
			//let select_category = this.currentPage.categories ? this.currentPage.categories.map(c=> c.id).join(',') : null;
			let title = 'Related articles'

			return {
				title,
				type: this.currentPostType,
				limit: 3,
				exclude: [this.currentPageID],
				//select_category
			}
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.summary {
	.heading {
		width: 100%;
	}
	.open-btn {
		display: flex;
		width: 100%;
		align-items: center;
		cursor: pointer;
		border: none;
		box-shadow: none;
		background-color: transparent;
		transition: all 0.2s ease-in-out;
		padding: 10px 25px;
		.txt {
			flex-grow: 1;
			text-align: left;
		}
		svg {
			width: 15px;
			height: 15px;
			margin: 5px 0;
		}
		span {
			line-height: 1;
		}
	}
	.accordion__item {
		background-color: var(--yellow);
		border-radius: $radius;
		max-width: $containerSmall;
		margin-left: auto;
		margin-right: auto;
		transition: all 0.2s ease-in-out;
		&.accordion__active {
			padding-left: 75px;
			padding-right: 75px;
			max-width: $containerA;
			padding-bottom: 50px;
			.open-btn {
				padding-top: 25px;
				padding-left: 0;
				padding-right: 0;
			}
		}
	}
	.summary-content {
	}
}
.single.post {
	overflow-x: hidden;
	.related-event-post {
		max-width: 950px;
		margin-left: auto;
		margin-right: auto;
	}
	.featured-video {
		margin: 0;
	}
	.post-img-hold {
		position: relative;
		&:after {
			content: '';
			position: absolute;
			top: 50px;
			bottom: 0;
			width: 50vw;
			transform: translateX(-100%);
			left: 100px;
			z-index: -1;
			background-color: var(--dark);
		}
	}
	.after-image {
		color: #fff;
		background-color: var(--dark);
		border-bottom-right-radius: $radius;
		padding-bottom: 50px;
		&.has-caption {
			padding: 25px 50px 25px 0;
		}
		p {
			margin-top: 0;
			margin-bottom: 0;
		}
	}
}
</style>
